/**
 * Ruta `/integracion` (009 · T029 · F6; contracts/ui.md §1): pestañas Conexión, Sincronizar,
 * Revisión e Historial.
 *
 * `validateSearch` acepta `tab` del catálogo completo (`INTEGRATION_TAB_IDS`); lo que no encaje se
 * descarta y la pantalla elige la pestaña por defecto según la conexión (sin verificar ⇒
 * `conexion`; verificada ⇒ `sincronizar`). El cambio de pestaña usa `replace`.
 */
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { IntegrationPage } from '../../features/integration/integration-page';
import { isIntegrationTab, type IntegrationTab } from '../../features/integration/tabs';

export interface IntegracionSearch {
  tab?: IntegrationTab;
}

export const Route = createFileRoute('/_app/integracion')({
  validateSearch: (search: Record<string, unknown>): IntegracionSearch => {
    const tab = search['tab'];
    return isIntegrationTab(tab) ? { tab } : {};
  },
  component: function IntegracionRoute() {
    const { tab } = Route.useSearch();
    const navigate = useNavigate({ from: Route.fullPath });
    return (
      <IntegrationPage
        tab={tab}
        onTabChange={(next) =>
          void navigate({ search: (prev) => ({ ...prev, tab: next }), replace: true })
        }
      />
    );
  },
});
